import React from "react";
import Icon from '@visa/vds/icon';

const MCSErrorText = (props) =>{

    const ErorrMessageStyle = {   
        color: "#d50000", 
        cursor: "text", 
        fontSize: ".75rem", 
        lineHeight: "1rem",
        marginBottom:".75rem",
        margin: "0",
        display: "flex",
    };

    return(
        <>
        <Icon style={{fill:"#d50000"}} name="error" resolution="tiny" />
        &nbsp;
        <span style={ErorrMessageStyle}>{props.text}</span>
        </>
    )
}

export default MCSErrorText